import React, { Component } from "react"; 
import Logo_Filter from "../img/ico/black_filter.png"

class FilterBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      addBinderActive: false,
    };
  }

  showAddBinder = () => {
    this.setState({ addBinderActive: !this.state.addBinderActive });
  };

  render() {
    return (
      <div className="searchBar">
          <input type="text" placeholder={this.props.placeholderText} className="fieldInput" onKeyUp={this.props.onUpdate}/>
          <img src={Logo_Filter}/>
      </div>
    );
  }
}
 
export default FilterBar;